module.exports = __webpack_public_path__ + "static/media/abstract_graph.3e8a9728.svg";